import { html, View } from 'rune-ts';
import { ButtonAction } from '../../../../../shared/components/atoms/ButtonAction/ButtonAction';
import klass from './MyPageEmptyScreen.module.scss';
import { font } from '../../../../../shared/typography';
import $dataStr from 'fxdom/es/dataStr.js';
import { makeExploreScreenNavigate, makeHomeScreenNavigate } from '../../../../../shared/app/navigate';
import { getResizedUrl } from '../../../../../shared/util/image';

const makePostMessageNavigateFnMap = {
  creator: makeExploreScreenNavigate,
  shop: makeHomeScreenNavigate,
};

interface MyPageEmptyScreenProps {
  title: string;
  title_desc: string;
  description: string;
  uri: string;
  visible: boolean;
  img_src: string;
  navigate?: 'creator' | 'shop';
}

export class MyPageEmptyScreen extends View<MyPageEmptyScreenProps> {
  override template() {
    const { navigate = 'shop', img_src } = this.data;

    return html`
      <div class="${klass.my_page_empty_screen}" data-visible="${this.data.visible}">
        <div class="${klass.my_page_empty_screen_img}">
          <img
            class="${klass.my_page_empty_screen_img_inner}"
            src="${getResizedUrl({
              url: img_src,
              width: 450,
              format: 'webp',
            })}"
            alt=""
          />
        </div>
        <div class="${klass.my_page_empty_screen_title} ${font('20_bold')}">${this.data.title}</div>
        <div class="${klass.my_page_empty_screen_title_desc} ${font('16_medium')}">
          ${this.data.title_desc}
        </div>
        <div class="${klass.my_page_empty_screen_more} ${font('16_bold')}">
          <a
            href="${this.data.uri}"
            data-post-message="${$dataStr(makePostMessageNavigateFnMap[navigate](this.data.uri))}"
          >
            ${new ButtonAction({
              label: this.data.description,
              klass: klass.my_page_empty_screen_button,
              type: 'blue',
              size: 'large',
            })}
          </a>
        </div>
      </div>
    `;
  }
}
